import { date as dateUtils, format } from 'quasar'
const { capitalize } = format

const prepareDateString = (value = '') => {
  return capitalize(value.toLowerCase())
}

export function onlyTime (value) {
  if (!value) return ''
  let innerValue = value.split('+')[0]
  let dateTimeObj = new Date(innerValue)
  return dateUtils.formatDate(dateTimeObj, 'HH:mm')
}

export function onlyDate (value) {
  if (!value) return ''
  value = value.split('+')[0]
  let currentDateTime = new Date()
  let dateTimeObj = new Date(value)
  if (dateUtils.getWeekOfYear(currentDateTime) === dateUtils.getWeekOfYear(new Date(dateTimeObj))) {
    return dateUtils.formatDate(dateTimeObj, 'dddd')
  }
  return dateUtils.formatDate(dateTimeObj, 'D MMMM')
}

export function dateFormat (value, format = 'DD-MM-YYYY HH:mm') {
  if (!value) return ''
  value = value.split('+')[0]
  let dateTimeObj = new Date(value)
  return prepareDateString(dateUtils.formatDate(dateTimeObj, format))
}
